"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addThreeTermBaseLoss = addThreeTermBaseLoss;
const baseLoss_js_1 = require("./baseLoss.js");
function addThreeTermBaseLoss(mfs, threeTerm, i, options) {
    if (!options.wxyzBaseLoss)
        return;
    let loss = (0, baseLoss_js_1.baseLoss)(threeTerm);
    for (const mf of loss) {
        if (options.w) {
            mfs.push(`HO${mf}`.replace('$', `$w${i} `));
        }
        if (options.x) {
            mfs.push(`H-1${mf}`.replace('$', `$x${i} `));
        }
        if (options.y) {
            mfs.push(`O-2P-1${mf}`.replace('$', `$y${i} `));
        }
        if (options.z) {
            mfs.push(`O-3H-1P-1(+)${mf}`.replace('$', `$z${i} `));
        }
    }
}
//# sourceMappingURL=addThreeTermBaseLoss.js.map